import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  usePostSupplierListMutation,
  useTotalSupplierCountMutation,
} from "../../../../store/api/itemapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
// import ConfigureColumns from "./ConfigureColumns";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import {useDeleteDocMutation} from '../../../../store/api/globalapi'
import useScreenHeight from "../../../../utils/useScreenHeight";

const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling , pageSize} = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setCountItemData] = useState(0);
  const [purchaseData, setPurchaseData] = useState({
    purchase_order: [],
    total_no_of_records: 0,
  });
  const [itemDataApi] = usePostSupplierListMutation();
  const [totalitemCountApi] = useTotalSupplierCountMutation();
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showFilters, setShowFilters] = useState(false)

  const [showExportPopup, setShowExportPopup] = useState(false);
  const doctype = "Supplier";
    const [deleteDoc] = useDeleteDocMutation();
		const [delPopupVisible, setDelPopupVisible] = useState(false);
		const [delSelectedId, setDelSelectedId] = useState(null);
		const [delmessage, setDelmessage] = useState();
		const [alreadySubmitData, setAlreadySubmitData] = useState(false);
		const [delDone, setDelDone] = useState(false);

  const filtersConfig = [
    { name: "siNo", label: "S. No.", width: "3.8%", type: 'text' },
    { name: "supplier_name", label: "Supplier Name", width: "17.7%", type: 'text' },
    { name: "supplier_group", label: "Supplier Group", width: "17.7%", type: 'text' },
    { name: "country", label: "Territory", width: "17.7%", type: 'text' },
    { name: "release_date", label: "Date", type: "date", width: "17.7%" },
    {
      name: "disabled",
      label: "Status",
      width: "10.7%",
      type: "select",
      options: [
        { value: "0", label: "Enabled" },
        { value: "1", label: "On Hold" },
      ],
    },
  ];

  const handleFilterChange = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };
  const handleView = (id) => {
    try {
      navigate(`/master/supplier/view-supplier/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("View failed:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      navigate(`/master/supplier/edit-supplier/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleDelete = (id) => {
		setDelSelectedId(id);
		setDelPopupVisible(true);
		setAlreadySubmitData(false);
		setDelmessage(`Are you sure you want to Delete this ${doctype}?`);
	};

	const delHandleCancel = () => {
		setDelPopupVisible(false);
		setDelSelectedId(null);
	};

	const delHandleConfirm = async () => {
		try {
			await deleteDoc({
				doctype:doctype,
				name: delSelectedId,
			}).unwrap();
			setDelmessage(`${doctype} ${delSelectedId} deleted successfully!`);
			setDelDone(true);
			setTimeout(() => {
				setDelPopupVisible(false);
				setDelSelectedId(null);
				setDelDone(false);
        getData();
        getCountData();
			}, 1000);
		} catch (err) {
			console.error("Deletion Failed:", err);

			let errorMessage = "Failed to delete the Purchase Receipt!";

			//If the server is sending the error message , we will extract it.
			if (err?.data?._server_messages) {
				try {
					const messageArr = JSON.parse(err.data._server_messages);
					if (messageArr && messageArr.length > 0) {
						//parse inner json object
						const messageObj = JSON.parse(messageArr[0]);
						if (messageObj?.message) {
							//extract the exact message we want
							const fullMessage = messageObj.message;
							errorMessage = fullMessage.split("You must")[0].trim();
							//remove html in the message
							errorMessage = errorMessage.replace(/<[^>]+>/g, "");
						}
					}
				} catch (parseError) {
					console.error("Error parsing server messages:", parseError);
				}
			}
			setDelPopupVisible(true);
			setDelmessage(errorMessage);
			setAlreadySubmitData(true);
		} finally {
			// setTimeout(() => {
			//     setDelPopupVisible(false);
			//     setDelSelectedId(null);
			// }, 2000);
		}
	};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "SI No.",
      name: "SI No.",
      accessor: "siNo",
      width: "5%",
      visible: true,
      sortable: false, // avoid enabling sort unless you manage it manually
      cellRenderer: (row) => row.siNo, // fallback also handled above
    },
    {
      header: "Supplier Name",
      name: "Supplier Name",
      accessor: "supplier_name",
      width: "17.7%",
      visible: true,
      sortable: false,
    },
    {
      header: "Supplier Group",
      name: "Supplier Group",
      accessor: "supplier_group",
      width: "17.7%",
      visible: true,
      sortable: false,
    },
    {
      header: "Territory",
      name: "Territory",
      accessor: "country",
      width: "17.7%",
      sortable: false,
      visible: true,
      // Custom sorting for numbers
      sortFn: (a, b) => parseInt(a.no_of_lines) - parseInt(b.no_of_lines),
    },

    {
      header: "Date",
      name: "Date",
      accessor: "release_date",
      width: "17.7%",
      visible: true,
      sortable: true,
      // Custom sorting for dates
      sortFn: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      header: "Status",
      name: "Status",
      accessor: "disabled",
      width: "10.7%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => {
        const isDisabled = row.disabled === 1; // 1 = On Hold, 0 = Enabled
        const label = isDisabled ? "On Hold" : "Enabled";
        const color = isDisabled ? "#D97706" : "#6366F1"; // Orange for On Hold, Green for Enabled

        return <span style={{ color }}>{label}</span>;
      },
    },

    {
      header: "Action",
      name: "Action",
      accessor: "action",
      width: "0%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.supplier_name}
          onView={() => handleView(row.supplier_name)}
          onEdit={() => handleEdit(row.supplier_name)}
          onDelete={() => handleDelete(row.supplier_name)}
        />
      ),
    },
  ]);
  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px" ,backgroundColor : '#E6A744' },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/supplier/create-supplier",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Supplier",
    },
  ];
    const getData = async () => {
			setLoading(true);

			try {
				// STEP 1: Clean filters
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);

				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";

				// STEP 2: Remove siNo from API filter
				const frappeFilters = Object.entries(filteredSearchInput)
					.filter(([key]) => key !== "siNo")
					.map(([key, value]) => {
						if (key === "release_date") {
							return ["Supplier", key, "=", value]; // ✅ Use exact match for date
						}
						return ["Supplier", key, "like", `%${value}%`];
					});

				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;

				const payload = {
					start: pageSize * (targetPage - 1),
					limit: pageSize,
					filters: frappeFilters,
					fields: [
						"supplier_name",
						"supplier_group",
						"release_date",
						"country",
						"disabled",
					],
				};

				const response = await itemDataApi(payload);
				const rawData = response.data.data;

				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
							(item) => item.siNo === parseInt(siNoFilter, 10)
					  )
					: numberedData;

				setPurchaseData(finalData);

				// Optional: update currentPage to reflect jump
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (error) {
				console.error("Error fetching supplier:", error);
			} finally {
				setLoading(false);
			}
		};

		const getCountData = async () => {
			setLoading(true);
			try {
				const response = await totalitemCountApi();
				if (response?.data) {
					setCountItemData(response?.data);
					//   console.log('count:', response?.data);
				}
			} catch (error) {
				console.error("Error fetching supplier count:", error);
			} finally {
				setLoading(false);
			}
		};
  useEffect(() => {
		if (pageSize > 0) {
			getData();
			getCountData();
		}
	}, [
		currentPage,
		filters,
		itemDataApi,
		totalitemCountApi,
		pageSize,
		screenHeight,
		screenScaling,
	]);

  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);
  return (
		<div
			className="container-fluid d-flex flex-column "
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "Supplier" },
					{ label: "Supplier List", style: { color: "#4b002b" } },
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}
				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType={doctype}
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={["siNo", "supplier_name", "action"]}
					/>
				)}

				<Table columns={visibleColumns} data={purchaseData} loading={loading} />

				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={totalRecords.message}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>
				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
				{showExportPopup && (
					<ExportCSV
            doctype={doctype}
            fieldsData={accessors}
						onClose={() => setShowExportPopup(false)}
					/>
				)}
			</ListLayout>
		</div>
	);
};

export default MainContent;
